var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatchingShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36.7964117px",
    height: "44.1825304px",
    viewBox: "0 0 36.7964117 44.1825304",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u76FE\u724C (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9757E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7638F1",
    offset: "99.9890734%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010\\u805A\\u878D\\u6613\\u3011\\u52A8\\u6001\\u5339\\u914D\\u9875_\\u7D2B\\u8272",
    transform: "translate(-168.338870, -176.598344)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(85.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u76FE\\u724C-(1)",
    transform: "translate(83.338870, 69.598344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8404986,7.85684914 L20.2602306,0.354180259 C20.201926,0.325706189 20.1418879,0.301051704 20.0804844,0.280367903 C18.9942737,-0.0934559675 17.7962783,-0.0934559675 16.7100677,0.280367903 C16.6489024,0.301321088 16.5886746,0.326083943 16.5303215,0.354180259 L0.955912236,7.85684914 C0.372147249,8.13828851 0,8.7361686 0,9.39238426 L0,21.0887855 C0,27.538795 2.78454258,33.3130642 7.90672295,37.3965542 L16.4640005,43.5575049 C17.0295711,43.9645806 17.7056857,44.1829959 18.3987913,44.1825297 C19.0765305,44.1825297 19.754504,43.9744257 20.3319416,43.5575049 L28.9553058,37.3467904 C34.0116339,33.3133023 36.7964112,27.5397474 36.7964112,21.0890236 L36.7964112,9.39238426 C36.7968795,8.7359305 36.4244979,8.13828851 35.8404986,7.85684914 Z M27.8988575,17.7924685 L17.7742494,28.3135866 C17.097682,29.0167088 15.9765533,28.9914698 15.3311543,28.2583464 L9.79183156,21.963581 C9.0222273,21.0890236 9.09604744,19.746353 9.95681372,18.9644183 L9.95704807,18.9641802 C10.8178143,18.1822454 12.1395464,18.2572483 12.9091506,19.1318057 L16.6608542,23.3948264 L24.9090246,14.8228308 C25.7161248,13.983989 27.0397317,13.9687504 27.8653455,14.7887818 C28.6911937,15.6088133 28.7061921,16.9536268 27.8988575,17.7924685 L27.8988575,17.7924685 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3982711,8.56912021e-07 L18.398,21.588 L16.6608542,23.3948264 L12.9091506,19.1318057 C12.1395464,18.2572483 10.8178143,18.1822454 9.95704807,18.9641802 C9.09604744,19.746353 9.0222273,21.0890236 9.79183156,21.963581 L15.3311543,28.2583464 C15.9765533,28.9914698 17.097682,29.0167088 17.7742494,28.3135866 L18.398,27.665 L18.3987913,44.1825297 C17.7826974,44.1829441 17.1800285,44.0104151 16.6564899,43.686168 L16.4640005,43.5575049 L7.90672295,37.3965542 C2.78454258,33.3130642 0,27.538795 0,21.0887855 L0,9.39238426 C0,8.7361686 0.372147249,8.13828851 0.955912236,7.85684914 L16.5303215,0.354180259 C16.5886746,0.326083943 16.6489024,0.301321088 16.7100677,0.280367903 C17.2541225,0.0931291984 17.8262213,-0.00032648348 18.3982711,8.56912021e-07 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillOpacity: 0.1738691,
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingShield);
export default __webpack_public_path__ + "static/media/matching-shield.dcfb5923b060e9a97a6bba974a105a97.svg";
export { ForwardRef as ReactComponent };